import { declinedBoxStyle, responseAdminBoxStyle, responseExpertBoxStyle, revokedBoxStyle, sentBoxStyle } from "../style";

export const stickyCellBase = {
  background: "#f5f5f5",
  zIndex: 10,
  fontWeight: 600,
  borderRight: "1px solid rgba(224, 224, 224, 1)",
  padding: "6px",
};


export const cellStyles = {
  width: "150px",
  textAlign: "center",
  background: "#f5f5f5",
  fontWeight: 600,
  padding: "6px",
  borderRight: "1px solid rgba(224, 224, 224, 1)",
  cursor: "pointer",
  userSelect: "none",
  "&:hover": {
    background: "#e0e0e0",
  },
};


// Constants
export const EXPERT_NAME_MAX_LENGTH = 25;
export const AGENDA_TITLE_MAX_LENGTH = 16;
export const EXPERT_NAME_CELL_WIDTH = "150px";
export const ACTIONS_CELL_WIDTH = "80px";
export const AGENDA_CELL_MIN_WIDTH = "120px";
export const ROW_HEIGHT = 38;

// Status configuration
export const STATUS_CONFIG = {
  RespondedByExpert: {
    text: "Response | Expert",
    style: responseExpertBoxStyle,
  },
  Declined: {
    text: "Declined",
    style: declinedBoxStyle,
  },
  RespondedByAdmin: {
    text: "Response | Admin",
    style: responseAdminBoxStyle,
  },
  Sent: {
    text: "Shared",
    style: sentBoxStyle,
  },
};
// Helper Functions
export const truncateExpertName = (name: string): string => {
  return name?.length > 25 ? name.slice(0, 25) + "…" : name;
};

export const truncateAgendaTitle = (title: string): string => {
  return title?.length > 16 ? title.slice(0, 16) + "…" : title;
};

export const getStatusDisplay = (status: string) => {
  let boxText = "";
  let boxSx: any = {
    background: "#fff",
    px: 1,
    py: 0.5,
    display: "inline-block",
  };

  if (status === "RespondedByExpert") {
    boxText = "Response | Expert";
    boxSx = { ...boxSx, ...responseExpertBoxStyle };
  } else if (status === "Declined") {
    boxText = "Declined";
    boxSx = { ...boxSx, ...declinedBoxStyle };
  } else if (status === "RespondedByAdmin") {
    boxText = "Response | Admin";
    boxSx = { ...boxSx, ...responseAdminBoxStyle };
  } else if (status === "Sent") {
    boxText = "Shared";
    boxSx = { ...boxSx, ...sentBoxStyle };
    
  } else if (status === "Revoked") {
    boxText = "Revoke";
    boxSx = { ...boxSx, ...revokedBoxStyle };
    
  } else if (status) {
    boxText = status;
    boxSx = { ...boxSx, ...sentBoxStyle };
  } else {
    // If status is empty, leave the box blank and don't apply style2
    boxText = "";
    boxSx = { ...boxSx };
  }

  return { boxText, boxSx };
};